import { useCallback, useMemo, useState } from "react";
import { notification } from "antd";
import { getNotificationHistory } from "~/services/notificationHistory";
import { IAlert } from "~/types/alert";
import { acknowledgeAlerts } from "~/services/alert";

export const useAlerts = () => {
  const [alerts, setAlerts] = useState<IAlert[]>([]);
  const [alertsLoading, setAlertsLoading] = useState(false);
  const [acknowledgeLoading, setAcknowledgeLoading] = useState(false);

  const fetchAlerts = useCallback(async () => {
    try {
      setAlertsLoading(true);
      const result = await getNotificationHistory();

      setAlerts(result?.filter((x) => !x.isAcknowledged) || []);
      return result;
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to fetch alerts",
      });
      return [];
    } finally {
      setAlertsLoading(false);
    }
  }, []);

  const handleAcknowledge = useCallback(
    async (alertIds: string[]) => {
      try {
        setAcknowledgeLoading(true);
        await acknowledgeAlerts(alertIds);
        await fetchAlerts();
      } catch (error) {
        notification.error({
          message: "Error",
          description: "Failed to acknowledge alert",
        });
      } finally {
        setAcknowledgeLoading(false);
      }
    },
    [fetchAlerts],
  );

  return useMemo(
    () => ({
      alerts,
      alertsLoading,
      acknowledgeLoading,
      fetchAlerts,
      acknowledgeAlert: handleAcknowledge,
    }),
    [alerts, alertsLoading, acknowledgeLoading, fetchAlerts, handleAcknowledge],
  );
};
